// @flow
import { makeStyles } from "@material-ui/core/styles";
export default makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  }
}), { index: 1 });